// @flow

import styled from 'styled-components';
import { COLORS, FONT_WEIGHT, TYPE_SCALE, SPACING, LINE_HEIGHT, BORDER_WIDTH } from 'clark-styles';

const { GREY_100, GREY_50 } = COLORS;
const { S_1, S_4 } = SPACING;
const { FW_100 } = FONT_WEIGHT;
const { TS_4, TS_6 } = TYPE_SCALE;
const { COPY, TITLE } = LINE_HEIGHT;
const { BW_3 } = BORDER_WIDTH;

const BORDER_COLOR = '#ffdfd0';

export const Container = styled.div`
  margin-right: ${S_4};
  padding-left: ${S_1};
  border-left: solid ${BW_3} ${BORDER_COLOR};
`;

export const Label = styled.span`
  ${TITLE};
  ${FW_100};
  ${TS_6};
  color: ${GREY_50};
`;

export const Data = styled.div`
  ${COPY};
  ${FW_100};
  ${TS_4};
  color: ${GREY_100};
`;



// WEBPACK FOOTER //
// ./src/components/data-highlight/styles.js